import React, {useState} from "react"
import {injectIntl, defineMessages} from "react-intl"
import intlProps from "../../state/helpers/IntlProps"
import proposalService from "../../state/proposal/proposalService"
import {isError} from "../../state/helpers/Error"
import ActionButton from "../button/actionbutton.component"

const messages = defineMessages({
    errorMsg: {
        id: "pdf.pdf_error_page.error_msg",
        defaultMessage: "The PDF failed to generate, please try again.",
    },
    btnMsg: {
        id: "pdf.pdf_error.retry_btn",
        defaultMessage: "Generate Pdf",
    }
})

const PDFErrorPage = (props: intlProps) => {

    const uri = window.location.search
    const urlParams = new URLSearchParams(uri)
    const hash = urlParams.get("hash")

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const retryPdfGeneration = () => {
        setIsLoading(true)
        proposalService.requestPdf(hash ??"").then((res) => {
            if (!isError(res)) {
                window.location.href = res.getPdfUri()
            }
        })
    }

    return (
        <div>
            <div className="d-flex justify-content-center my-4">
                <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                    <div className="row">
                        <div className="col-12 mt-4">
                            <h1 className="text-center">
                                <img src='/images/QuoteM_horizontal_flat.png' height='80px'/>
                            </h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="row justify-content-center flex-fill">
                                <div className="col-sm-12 col-sx-12 col-md-12 col-lg-12 col-xl-12 bg-white
                                ui-module py-4 px-3 px-sm-5">
                                    <div className="row justify-content-center mb-3 mt-3">
                                        {props.intl.formatMessage(messages.errorMsg)}
                                    </div>
                                    <div className="row justify-content-center mb-3 mt-3">
                                        <ActionButton
                                            type="button"
                                            onClick={retryPdfGeneration}
                                            className="btn btn-primary"
                                            isLoading={isLoading}
                                            disabled={isLoading}
                                        >
                                            {props.intl.formatMessage(messages.btnMsg)}
                                        </ActionButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(PDFErrorPage)


// WEBPACK FOOTER //
// ./src/common/pdf/PDFErrorPage.tsx